module.exports = __webpack_public_path__ + "img/about-icon3.9ef5df5c.png";